import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { AddIdnComponent } from "./add-idn/add-idn.component";
import { IdnsComponent } from "./idns.component";

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardWithForcedLogin],
        data: { expectedPermissions: HSPAPermission.IDNsAccess },
        component: IdnsComponent
    },
    {
        path: 'add-idn',
        canActivate: [AuthGuardWithForcedLogin],
        data: { expectedPermissions: HSPAPermission.OnboardingIDNs },
        component: AddIdnComponent
    },
    {
        path: 'edit-idn/:id',
        canActivate: [AuthGuardWithForcedLogin],
        data: { expectedPermissions: HSPAPermission.OnboardingIDNs },
        component: AddIdnComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class IdnsRoutingModule { }
